import IOwnThisApi from '../api/IOwnThisApi';
import IOwnThisConstants from '../constants/IOwnThisConstants';

function createIOwnThisSetting(metadataId) {
  return {
    metadataId,
    types: [
      IOwnThisConstants.CREATE_I_OWN_THIS_SETTING_REQUEST,
      IOwnThisConstants.CREATE_I_OWN_THIS_SETTING_SUCCESS,
      IOwnThisConstants.CREATE_I_OWN_THIS_SETTING_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) => IOwnThisApi.createIOwnThisSetting({
      metadataId,
      userId: state.getIn(['auth', 'currentUserId'])
    }, client)
  };
}

function removeIOwnThisSetting(metadataId, ownerSettingId) {
  return {
    metadataId,
    ownerSettingId,
    types: [
      IOwnThisConstants.REMOVE_I_OWN_THIS_SETTING_REQUEST,
      IOwnThisConstants.REMOVE_I_OWN_THIS_SETTING_SUCCESS,
      IOwnThisConstants.REMOVE_I_OWN_THIS_SETTING_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) => IOwnThisApi.removeIOwnThisSetting({
      ownerSettingId,
      userId: state.getIn(['auth', 'currentUserId'])
    }, client),
    apiSuccess: () => ({
      deletedEntities: [`ugc.iOwnThis.${ownerSettingId}`]
    })
  };
}

export default {
  createIOwnThisSetting,
  removeIOwnThisSetting
};



// WEBPACK FOOTER //
// ./app/actions/IOwnThisActions.js